import { useEffect } from 'react';
import { getCurrentSubdomain } from '../../commons/domain';

function ChatWidget() {
    useEffect(() => {
        const isDev = getCurrentSubdomain().indexOf('dev') > -1;

        if (isDev) {
            window.$crisp = [];
            window.CRISP_WEBSITE_ID = '7d2700d9-fc29-46d0-8ba5-cebb0a7caef2';

            const script = document.createElement('script');
            script.src = 'https://client.crisp.chat/l.js';
            script.async = true;
            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, []);

    return null; // No UI needed here, it's just injecting the script
}

export default ChatWidget;



// WEBPACK FOOTER //
// ./src/components/Chat/ChatWidget.js